import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { viewPage, segment, useUserLocation } from '@hotjar/tracking';
import * as legacySegment from '../domains/common/tracking/segment';
import { getRouteConfigByPath } from '../utils/routing';

export const useTrackRouteChange = (): void => {
  const { pathname } = useLocation();
  const { data: userLocation } = useUserLocation();

  useEffect(() => {
    segment.setAnonymizedUserId(userLocation?.ip ?? '0.0.0.0');
    segment.setCountryCode(userLocation?.country ?? undefined);

    legacySegment.setAnonymizedUserId(userLocation?.ip ?? '0.0.0.0');
    legacySegment.setCountryCode(userLocation?.country ?? undefined);
  }, [userLocation]);

  useEffect(() => {
    const routeConfig = getRouteConfigByPath(pathname);
    if (routeConfig?.name !== undefined) {
      // We need to wait a bit to get the title changed. This will send the new title and not the previous one
      if (userLocation !== undefined) {
        setTimeout(() => {
          viewPage(routeConfig.name);
        }, 100);
      }
    }
  }, [pathname, userLocation]);
};
